'use strict';

var Misc = require('utils/misc');

module.exports = Marionette.LayoutView.extend({
    template: require('components/common/templates/contract'),

    ui: {
        contractNr: 'select.js-contract',
    },

    events: {
        'click button#js-success': 'onSubmit',
    },

    serializeData: function () {
        var data = {};
        data.contractNr = this.options.contractNrIdx;
        data.contractNrList = this.options.contractNrList;
        return data;
    },
    onShow: function () {
        Misc.initSelectPicker();
    },
    onRender: function () {
        Misc.initSelectPicker();
    },
    onSubmit: function (e) {
        e.preventDefault();
        var contractNrId = this.ui.contractNr.val();
        this.options.save_cb(contractNrId);
    },
});
